export default {
    'user.invalid.credentials': 'Estas credenciais não correspondem aos nossos dados.',
    'user.unable.to.create.token': 'Não foi possível gerar um token para este utilizador.',
    'user.not.found': 'Utilizador não encontrado.',
    'user.logged.out': 'O utilizador acabou de sair.',
    'user.logout.error': 'Não foi possível efetuar o logout.',
    'user.password.reset.sent': 'Foi enviado um email com um link para redefinir a sua password!',
    'user.password.reset.invalid': 'Não foi possível enviar um email com um link para redefinir a sua password.',
    'user.password.reset': 'Password redefinida!',
    'user.invalid.token': 'O token para redefinir a password é inválido.',
    'user.verify.email': 'Email não validado.',
    'user.unable.to.create': 'Não foi possível criar o utilizador.',
    'user.email.already.exist': 'Já existe um utilizador com este email.',
    'user.not.logged.in': 'O utilizador não está autenticado.',
    'user.validation.check.password': 'A password que introduziu não coincide com a sua password atual',
    'proposal.update': 'Só é possível editar uma proposta com o estado "Rascunho"',
    'products.upload.error': 'Linha ignorada pois encontra-se mal formatada, deve conter 20 colunas.'
}
